<template>
  <div>
    <PageTitle title="Floor" :btnCreate="false" />
    <ValidationObserver ref="createObserver" v-slot="{ validate }" class="px-6">
      <tr v-if="editFloorId == null">
        <th>
          <ValidationProvider
            v-slot="{ errors }"
            name="Name"
            vid="name"
            rules="required|min:3|no_spaces_only"
          >
            <v-col cols="12" class="pl-0">
              <v-text-field
                :error-messages="errors"
                required
                dense
                label="Name"
                v-model="newFloors.name"
                outlined
                @blur="newFloors.name = newFloors.name.trim()"
              ></v-text-field>
            </v-col>
          </ValidationProvider>
        </th>

        <th class="title">
          <v-col cols="4">
            <permission-control permissionName="Floor Create">
              <v-btn
                @click="SavePlace()"
                depressed
                small
                class="text-white btn_blue btn_medium w-100"
                >Create</v-btn
              >
            </permission-control>
          </v-col>
        </th>
      </tr>
    </ValidationObserver>

    <v-container fluid class="lighten-12 content">
      <ValidationObserver ref="observer" v-slot="{ validate, reset }">
        <v-card class="lighten-12 card-content mb-2">
          <v-row class="ma-0 align-right">
            <TableFilters
              :filters="['status', 'search']"
              v-model="filter"
              :columns="columns"
            ></TableFilters>
            <ImportExportMenu :permission="'Floor Report'"></ImportExportMenu>
          </v-row>
        </v-card>

        <LoadingComponent
          v-if="isLoading"
          :visible="isLoading"
        ></LoadingComponent>
        <v-card class="lighten-12 mt-2">
          <v-container fluid class="light gray lighten-12">
            <v-row>
              <v-card-text class="pa-0">
                <v-data-table
                  :items-per-page="paginationOptions.perPage"
                  :fixed-header="true"
                  :headers="headers"
                  :items="floors"
                  item-key="id"
                  hide-default-footer
                >
                  <!-- No -->
                  <template v-slot:item.no>
                    <v-icon>mdi-vuetify</v-icon>
                  </template>
                  <!-- Name -->
                  <template v-slot:item.name="{ item }"
                    ><ValidationProvider
                      v-slot="{ errors }"
                      name="Name"
                      vid="name"
                      v-if="item.id == editFloorId"
                      rules="required|min:3|no_spaces_only"
                    >
                      <v-text-field
                        v-model="newFloors.name"
                        :error-messages="errors"
                        :value="item.name"
                        outlined
                        class="pt-3"
                        @blur="newFloors.name = newFloors.name.trim()"
                      ></v-text-field>
                    </ValidationProvider>
                    <p v-else>{{ item.name }}</p>
                  </template>

                  <!-- Status -->
                  <template v-slot:item.status="{ item }" :slot-scope="props">
                    <toggle-button
                      v-model="newFloors.is_active"
                      v-if="editFloorId == item.id"
                      :disabled="editFloorId != item.id"
                      :value="item.is_active"
                      :width="80"
                      :labels="{ checked: 'Active', unchecked: 'Archeived' }"
                    ></toggle-button>
                    <v-chip
                      v-else
                      :x-small="true"
                      class="ma-2"
                      label
                      text-color="white"
                      :color="getStatusColor(item.is_active)"
                      dark
                      >{{ item.is_active ? "Active" : "Archived" }}</v-chip
                    >
                  </template>

                  <!-- Action -->
                  <template v-slot:item.action="{ item }">
                    <v-menu offset-y transition="scroll-y-transition">
                      <template v-slot:activator="{ attrs, on }">
                        <v-icon
                          v-show="editFloorId != item.id"
                          v-bind="attrs"
                          v-on="on"
                          >mdi-dots-vertical</v-icon
                        >
                        <v-btn
                          v-show="editFloorId == item.id"
                          color="secondary"
                          fab
                          x-small
                          dark
                          class="ma-1"
                        >
                          <v-icon
                            depressed
                            small
                            link
                            @click="CancelPlace(item)"
                            >clear</v-icon
                          ></v-btn
                        >
                        <v-btn
                          v-show="editFloorId == item.id"
                          color="green"
                          fab
                          x-small
                          dark
                          ><v-icon link @click="UpdateFloor(item)"
                            >done</v-icon
                          ></v-btn
                        >

                        <!-- {{editFloorId==item.id}} -->
                      </template>

                      <v-list class="actions">
                        <permission-control permissionName="Floor Edit">
                          <v-list-item link @click="EditFloor(item)">
                            <span>
                              <v-icon v-bind="attrs" v-on="on"
                                >mdi-pencil-box-outline</v-icon
                              >Edit
                            </span>
                          </v-list-item>
                        </permission-control>
                        <permission-control permissionName="Floor Soft Delete">
                          <v-list-item link @click="openConfirmation(item)">
                            <span>
                              <v-icon v-bind="attrs" v-on="on">
                                {{
                                  item.is_active
                                    ? "mdi-archive"
                                    : "mdi-checkbox-marked-circle"
                                }}
                              </v-icon>
                              {{ item.is_active ? "Archieve" : "Active" }}
                            </span>
                          </v-list-item>
                        </permission-control>

                        <permission-control permissionName="Place Soft Delete">
                          <v-list-item
                            link
                            dense
                            @click="onDeleteClickedItem(item)"
                          >
                            <span>
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-delete
                              </v-icon>
                              Delete
                            </span>
                          </v-list-item>
                        </permission-control>
                      </v-list>
                    </v-menu>
                  </template>
                  <template v-slot:footer>
                    <pagination
                      @paginationOptions="setPaginationOptions"
                      @response="setResponseData"
                      url="hms/floors"
                      :filter="filter"
                      ref="pagination"
                    >
                    </pagination>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-row>
          </v-container>
        </v-card>
      </ValidationObserver>
      <!-- </v-card> -->
      <div class="d-flex justify-center align-center"></div>
    </v-container>
  </div>
</template>
<script>
import TableFilters from "@/components/base/TableFilters";

import { required, email, max, regex } from "vee-validate/dist/rules";
import { mapState } from "vuex";
import pagination from "../../shared/components/pagination";
import confirmation from "../../shared/components/confirmation";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("min", (value) => {
  if (value.length >= 3) {
    return true;
  }
  return "Please enter above three characters";
});
extend("no_spaces_only", {
  validate: (value) => {
    return value && value.trim().length > 0;
  },
  message: "{_field_} cannot be empty or spaces only",
});

extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});
extend("regex", {
  ...regex,
  message: "The value is not a valid phone number",
});
export default {
  components: {
    pagination,
    ValidationProvider,
    TableFilters,
    ValidationObserver,
  },
  data() {
    return {
      floors: [],
      paginationOptions: {},
      isLoading: false,
      pagination1: {
        descending: true,
        page: 1,
        rowsPerPage: 2,
        sortBy: "fat",
        totalItems: 0,
        floorErrors: null,
        rowsPerPageItems: [1, 2, 4, 8, 16],
      },
      guest: [],
      pagination: {
        page: 1,
        itemsPerPage: 2,
      },
      page: 1,
      status: [
        { text: "Active", value: "active" },
        { text: "Archived", value: "archived" },
      ],
      columns: [
        {
          text: "Name",
          value: "name",
          show: true,
          disabled: false,
          width: "40%",
        },

        {
          text: "Status",
          value: "status",
          show: true,
          disabled: false,

          width: "40%",
        },
        {
          text: "Actions",
          value: "action",
          show: true,
          disabled: false,

          width: "40%",
        },
      ],
      newFloors: { name: "", id: "", is_active: "" },
      filter: {
        name: "",
        search: "",
        status: "",
      },

      // For edit purpose
      editFloorId: null,
    };
  },
  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    clearFilter() {
      this.filter = {};
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },
    setResponseData(floor) {
      this.floors = floor;
    },

    CancelPlace(item) {
      this.refreshData();
      this.editFloorId = null;
      this.newFloors = {};
    },
    SavePlace() {
      const isValid = this.$refs.observer.validate();
      if (isValid) {
        this.isLoading = true;
        this.CreateFloors();
      }
    },

    CreateFloors() {
      let Floorsname = this.newFloors;
      this.$store
        .dispatch("Floor/CreateFloors", Floorsname)
        .then((res) => {
          //this.succeeed = true;

          this.$toast.success("Places created  succesfully");
          this.refreshData();
          this.$refs.createObserver.reset();
          this.isLoading = false;
          this.newFloors = {};
        })
        .catch((err) => {s
          this.$refs.observer.setErrors(err.data.error);
          this.$toast.error("Places created  failed");
          this.messages = err.data.title;
          this.isLoading = false;
        });
    },
    async onDeleteClickedItem(item) {
      confirmation.dialog = true;
      this.$confirm("Do you want to " + "Delete " + item.name + " ?").then(
        (res) => {
          if (res) {
            this.$store
              .dispatch("Floor/DeleteFloor", item.id)
              .then((res) => {
                this.refreshData();
                const msg = item.name + " deleted";
                this.$toast.success("Successfully  " + msg);
              })
              .catch((err) => {
                this.$toast.error(item.name + " is not deleted");
              });
          } else {
          }
        }
      );
    },
    UpdateFloor(data) {
      let floor = _.cloneDeep(data);
      this.$store
        .dispatch("Floor/EditFloors", floor)
        .then((res) => {
          //
          //   this.newFloors =[]

          this.editFloorId = null;
          this.newFloors = {};
          this.$toast.success("Floor edited  successfully");
          this.$refs.observer.reset();
          this.refreshData();
        })
        .catch((err) => {
          this.$refs.observer.setErrors(err.data.error);
          this.floorErrors = err.data.error.name;
          this.messages = err.data.title;
          this.$toast.error("Floor edited failed");
        });
    },

    EditFloor(data) {
      this.newFloors = data;
      this.editFloorId = data.id;
    },
    getStatusColor(is_active) {
      return is_active ? "green" : "gray";
    },
    openConfirmation(Floor) {
      confirmation.dialog = true;
      this.$confirm(
        "Do you want to " +
          (Floor.is_active ? "Archive " : "Active ") +
          Floor.name +
          " ?"
      ).then((res) => {
        if (res) {
          this.$store
            .dispatch("Floor/ActiveOrArchiveFloors", Floor.id)
            .then((res) => {
              this.refreshData();
              const msg = Floor.is_active ? "archived" : "activated";
              this.$toast.success("Successfully  " + msg);
            })
            .catch((err) => {
              this.$toast.error("Floors is not Archived");
            });
        } else {
        }
      });
    },
  },
  computed: {
    headers: function() {
      return this.columns.filter((item) => item.show == true);
    },
  },
  created() {
    this.GetPlaces();
    this.refreshData();
  },
};
</script>
